import React from "react";
import { Box, Typography } from "@mui/material";
import { BRAND, DIM } from "../theme/index.js";

interface Props {
  icon: React.ReactElement;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action }: Props) {
  return (
    <Box sx={{ textAlign: "center", py: 8, px: 3 }}>
      <Box sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 64,
        height: 64,
        borderRadius: "12px",
        backgroundColor: DIM.cyan,
        border: `1.5px solid ${BRAND.cyan}`,
        mb: 2.5,
        "& .MuiSvgIcon-root": { fontSize: 32, color: BRAND.cyan },
      }}>
        {icon}
      </Box>
      <Typography variant="h4" gutterBottom>{title}</Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 360, mx: "auto" }}>
          {description}
        </Typography>
      )}
      {action}
    </Box>
  );
}
